import React from 'react'
import Header from './Components/Header'

export default function Privacy() {
  return (
    <div>
      <Header/>
      <h1>This is privacies</h1>
    </div>
  )
}
